<template>
  <div class="homePage" :style="this.$store.state.note">
    <div class="homePage-left">
      <Classification></Classification>
    </div>
    <div class="homePage-right">
      <img class="homePage-right-lamp" src="../../static/image/lamp.png" alt />
      <div class="homePage-right-content">
        <div :style="'height:' + this.height + 'px'">
          <img :src="this.$store.state.classUrl" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 分类选择
import Classification from "../classification/classification.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
export default {
  components: {
    Classification
  },
  data() {
    return {
      height: 0
    }
  },
  //页面初始化
  created() {
    this.$message({
      message: "已进入PC模式 建议使用鼠标操作",
      type: "success"
    });

    this.height = document.documentElement.clientHeight || document.body.clientHeight;
    console.log(this.height)

    this.$store.state.classUrl='';
  },
  methods: {
  }
};
</script>

<style >
.homePage {
  width: 100%;
  height: 100%;
  display: flex;
}
.homePage-left {
  width: 580px;
  background: #000;
  opacity: 0.8;
}
.homePage-right {
  position: relative;
  width: 1340px;
}
.homePage .homePage-right .homePage-right-lamp {
  width: 12%;
  height: 24.8%;
  position: absolute;
  left: 0;
  z-index: 1;
}

.homePage .homePage-right .homePage-right-content {
  position: absolute;
  left: 15%;
  right: 15%;
  text-align: center;
}
.homePage-right-content div{
  width: 100%;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding: 30px 0;
  margin: 0 auto;
}
.homePage .homePage-right .homePage-right-content div img {
  max-width: 100%;
}
</style>